import { ActionContext } from 'vuex';

import IState from '@/interfaces/IState';
import backendParams from '@/libs/backend/backendParams';
import API from '@/libs/backend/restAPI';
import cloneDeep from 'lodash.clonedeep';

export default (context: ActionContext<IState, IState>, payload: any) => {
    // @ts-ignore
    const params = backendParams[payload.request];

    const API_VERSION = params.path === '/info';

    const API_HOST = process.env.VUE_APP_API_HOST;

    const backendPath = API_VERSION ? API_HOST : API_HOST + '/api';

    const requestURL = `${backendPath}${params.path}`;
    const clonedPayload = cloneDeep(payload);
    switch (params.method) {
        case 'POST':
            return API.POST(requestURL, clonedPayload.data);
        case 'GET':
            return API.GET(requestURL, clonedPayload);
        case 'PUT':
            return API.PUT(requestURL, clonedPayload.data);
        case 'DELETE':
            return API.DELETE(requestURL, clonedPayload);
    }
};
